import React, { useCallback, useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { DataService, updateUser, getUser } from "@app/services";
import { AuthContext } from "@app/providers";
import { objectComparision, useLocation } from "@app/utils";
import {
  Button,
  Input,
  ProfileUploader,
  ProfileUpdtaeDialog,
  Layout,
  Toast,
  Loader,
  Icon,
} from "@app/components";
import { FormFlexWrapper, FlexWrapper, FormHeader, FormTitle } from "@app/components/commonStyles";
import { ButtonContainer, ImageContainer } from "./profile-component";

export default function StudentUserProfile() {
  const { register, handleSubmit, errors, setValue, clearErrors }: any =
    useForm({
      mode: "onBlur",
    });
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [imageError, setImageError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [profileImage, updateProfileImage] = useState<string>("");
  const [profileData, updateProfileData] = useState<any>();
  const [buttonText, setButtonText] = useState<string>("Save");
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const { navigate } = useLocation();

  const [userDetails, setUserDetails] = useState(userInfo.userJson);
  const assignValuesToForm = useCallback(() => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo.sessionToken,
      userId: userDetails.userId,
    });
    getUser(params)
      .then((res) => {
        setLoading(false);
        if (res._responseStatus) {
          const user = JSON.parse(res.userJson);
          setUserDetails(user);
          updateProfileImage(user.thumbnailAsset);
          setValue("firstName", user.firstName);
          setValue("lastName", user.lastName);
          setValue("schoolName", user.schoolName);
          setValue("schoolCity", user.schoolCity);
          setValue("schoolZip", user.schoolZip);
          setValue("email", user.email);
        } else if (res.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });

    // eslint-disable-next-line
  }, [setValue]);
  useEffect(() => {
    // console.log(userDetails)
    localStorage.setItem("first", userDetails.firstName)
    localStorage.setItem("last", userDetails.lastName)
    updateProfileImage(userDetails.thumbnailAsset);

    // assignValuesToForm();
  }, []);

  function onSubmit(data: any) {
    if (imageError) return;
    const comparedData: any = objectComparision(userDetails, data);
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      userType: userDetails.userType,
      sessionToken: userInfo.sessionToken,
      ...comparedData,
    });
    if (profileImage && profileImage.length) {
      if (
        profileData &&
        userDetails &&
        userDetails.profileUrl !== profileData.originalAsset
      ) {
        Object.assign(params, {
          profileUrl: profileData.originalAsset,
          mediumThumbnailAsset: profileData.mediumThumbnailAsset,
          smallThumbnailAsset: profileData.smallThumbnailAsset,
          thumbnailAsset: profileData.thumbnailAsset,
        });
      }
    }

    setButtonText("Saving...");

    updateUser(params)
      .then((response: any) => {
        setButtonText("Save");
        if (response._responseStatus === 1) {
          DataService.sendMessage({ key: "userJson", data: response.userJson });
          localStorage.setItem("userData", JSON.stringify(response));
          localStorage.setItem("first", response.userJson.firstName)
          localStorage.setItem("last", response.userJson.lastName)
          setUserDetails(response.userJson);
          setUserInfo(response);
          setShowSuccess(true);
          setDisableButton(true);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
        setButtonText("Save");
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
  }

  function onCancel() {
    // assignValuesToForm();
    setValue("firstName",userDetails.firstName)
    setValue("lastName",userDetails.lastName)
    clearErrors();
    setDisableButton(true);
    updateProfileData("");
    setImageError(false);
    updateProfileImage(userDetails.thumbnailAsset);
  }

  function onChange(data: any) {
    if (data.target.value !== userDetails[data.target.name]) {
      setDisableButton(false);
    }
  }
  function Portal() {
    navigate("/create-avatar")
  }

  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
        <FormHeader>
          <span className="back-icon" onClick={() => Portal()}>
            <Icon name="backArrow" />
          </span>
          <FormTitle className="justify-center">
            <h3 className="primary-header text-center">My Account</h3>
          </FormTitle>
        </FormHeader>
        <ImageContainer>
          <ProfileUploader
            name="profileUrl"
            background={profileImage}
            onUpdateImage={updateProfileImage}
            onUpdateImageData={updateProfileData}
            setImageError={setImageError}
            imageError={imageError}
          />
        </ImageContainer>
        <FormFlexWrapper className="two-child-layout mb-0">
          <div className="child mb-0">
            <Input
              label="First Name"
              placeholder="First Name"
              name="firstName"
              defaultValue={userDetails.firstName}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.firstName && "Please enter First Name"}
            />
          </div>
          <div className="child">
            <Input
              label="Last Name"
              placeholder="Last Name"
              name="lastName"
              defaultValue={userDetails.lastName}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.lastName && "Please enter Last Name"}
            />
          </div>
        </FormFlexWrapper>
        {userDetails.schoolAccountReg && (
          <>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  label="School Name"
                  placeholder="School Name "
                  name="schoolName"
                  defaultValue={userDetails.schoolName}
                  disable={true}
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="two-child-layout mb-0">
              <div className="child">
                <Input
                  label="City"
                  placeholder="City"
                  name="schoolCity"
                  defaultValue={userDetails.city}
                  disable={true}
                />
              </div>
              <div className="child">
                <Input
                  label="Zip Code"
                  placeholder="Zip Code"
                  defaultValue={userDetails.zip}
                  name="schoolZip"
                  disable={true}
                />
              </div>
            </FormFlexWrapper>
          </>
        )}
        <FormFlexWrapper>
          <div className="child only-child">
            <Input
              label="Username"
              placeholder="Username"
              name="email"
              defaultValue={userDetails.email}
              register={register({})}
              disable={true}
            />
          </div>
        </FormFlexWrapper>

        <FlexWrapper className="justify-end">
          <Button
            disabled={disableButton}
            variant="text"
            customClass="mr-1 mr-sm-0 mb-sm-1"
            type="button"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <ButtonContainer
            disabled={buttonText === "Saving..." || disableButton}
            style={{ width: "unset" }}
          >
            <Button variant="newsecondary" type="submit">
              {buttonText}
            </Button>
          </ButtonContainer>
        </FlexWrapper>
      </form>
      {showSuccess && (
        <ProfileUpdtaeDialog
          onClose={() => setShowSuccess(false)}
          message="Changes updated successfully"
          addChild={() => ''}
        />
      )}
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        onClose={() => setShowToast(false)}
      />
      {/* {loading && <Loader />} */}
    </Layout>
  );
}
